import React from "react";
//PrimeReact Components
import * as pr from "../../../../common/PrimeComponents";
import { ViewState } from "../../../../common/config/AppConstants";
import * as format from "../../../../common/FormatFunctions";
import { ListValueDisplay } from "../../../Common/ListValueDisplay";

export class PartDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div>
        <div
          className="ui-g-12 card-round"
          onClick={e => {
            if (format.isFunction(this.props.onClick)) {
              this.props.onClick(bean);
            }
          }}
        >
          <div className="ui-g-12">
            {/*Empty div for spacing*/}
            <label />
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Name: </b>
              <label>{bean.name || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Short Description: </b>
              <label>{bean.shortDescription || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Long Description: </b>
              <label>{bean.longDescription || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Type: </b>
              <label>{bean.operationalType || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Stock Type: </b>
              <label>{bean.stockType || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>SKU: </b>
              <label>{bean.sku || "Not Set"}</label>
            </div>
            <div className="ui-g-6">
              <b>Price: </b>
              <label>{bean.price || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <b>Cost: </b>
              <label>{bean.cost || "Not Set"}</label>
            </div>
          </div>
          {/* <div>{this.getCustomValuesDisplay(bean)}</div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Products/legacy/UI/PartDisplay.js